export function arrayBufferToBase64(buffer) {
  var bytes = new Uint8Array(buffer);
  var binary = '';
  for (var i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

export function isAndroidWebView() {
  return typeof window !== 'undefined'
    && window.ExportBridge
    && typeof window.ExportBridge.exportFile === 'function';
}

export function isIOSWebView() {
  return typeof window !== 'undefined'
    && window.webkit
    && window.webkit.messageHandlers
    && window.webkit.messageHandlers.exportFile
    && typeof window.webkit.messageHandlers.exportFile.postMessage === 'function';
}

export function downloadBlobInBrowser(blob, fileName) {
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  setTimeout(function () {
    URL.revokeObjectURL(url);
    if (a.parentNode) a.parentNode.removeChild(a);
  }, 1000);
}

export function deliverFile(arrayBuffer, fileName, mime) {
  if (isAndroidWebView()) {
    var base64 = arrayBufferToBase64(arrayBuffer);
    window.ExportBridge.exportFile(base64, fileName, mime);
    return;
  }

  if (isIOSWebView()) {
    var base64ios = arrayBufferToBase64(arrayBuffer);
    window.webkit.messageHandlers.exportFile.postMessage({
      base64: base64ios,
      fileName: fileName,
      mime: mime
    });
    return;
  }

  var blob = new Blob([arrayBuffer], { type: mime });
  downloadBlobInBrowser(blob, fileName);
}

export function stringToUtf8Bytes(str) {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(str)
  }

  var utf8 = []
  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i)
    if (charcode < 0x80) utf8.push(charcode)
    else if (charcode < 0x800) {
      utf8.push(
        0xc0 | (charcode >> 6),
        0x80 | (charcode & 0x3f)
      )
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(
        0xe0 | (charcode >> 12),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      )
    } else {
      // surrogate pair
      i++
      charcode =
        0x10000 +
        (((charcode & 0x3ff) << 10) |
          (str.charCodeAt(i) & 0x3ff))
      utf8.push(
        0xf0 | (charcode >> 18),
        0x80 | ((charcode >> 12) & 0x3f),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      )
    }
  }
  return new Uint8Array(utf8)
}
